import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  isGetClientLoading: false,
  selectedContactsIds: [],

  contactsExportDataIsLoaded: false,
  contactsExportData: {},

  contacts: {},
  contactsAreLoaded: false,
  contactsError: null,
  contactsRevision: 0,
  contactsTotals: {},
  contactsTotalsKey: null,
  contactsTotalsAreLoaded: false,
  contactsTotalsError: null,

  favorites: [],
  favoritesAreLoaded: false,

  crmFilterIsLoaded: false,
  crmFilter: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CRM_REFRESH_CONTACTS:
      return { ...state, contactsRevision: state.contactsRevision + 1 };
    case ActionTypes.GET_CONTACTS_EXPORTS[REQUEST]:
      return { ...state, contactsExportDataIsLoaded: false };
    case ActionTypes.GET_CONTACTS_EXPORTS[SUCCESS]:
      return { ...state, contactsExportData: action.data, contactsExportDataIsLoaded: true };
    case ActionTypes.GET_CONTACTS_EXPORTS[FAILURE]:
      return { ...state, error: action.error, userExportDataIsLoaded: false };
    case ActionTypes.CRM_SET_SELECTED_CONTACTS_IDS: {
      return { ...state, selectedContactsIds: action.data };
    }
    case ActionTypes.GET_CONTACTS[REQUEST]:
      return { ...state, contactsAreLoaded: false, contactsError: null };
    case ActionTypes.GET_CONTACTS_TOTALS[REQUEST]:
      return {
        ...state,
        contactsTotals: {},
        contactsTotalsKey: action.key,
        contactsTotalsAreLoaded: false,
        contactsTotalsError: null,
      };
    case ActionTypes.GET_CONTACTS[SUCCESS]:
      return { ...state, contacts: action.data, contactsAreLoaded: true, contactsError: null };
    case ActionTypes.GET_CONTACTS[FAILURE]:
      return { ...state, contactsError: action.error, contactsAreLoaded: true, contacts: { results: [], count: 0 } };
    case ActionTypes.GET_CONTACTS_TOTALS[SUCCESS]:
      if (action.key !== state.contactsTotalsKey) return state;
      return { ...state, contactsTotals: action.data, contactsTotalsAreLoaded: true, contactsTotalsError: null };
    case ActionTypes.GET_CONTACTS_TOTALS[FAILURE]:
      if (action.key !== state.contactsTotalsKey) return state;
      return { ...state, contactsTotals: {}, contactsTotalsAreLoaded: true, contactsTotalsError: action.error };

    case ActionTypes.GET_CRM_CLIENT[REQUEST]:
      return { ...state, isGetClientLoading: false };
    case ActionTypes.GET_CRM_CLIENT[SUCCESS]:
      return { ...state, isGetClientLoading: true };
    case ActionTypes.GET_CRM_CLIENT[FAILURE]:
      return { ...state, isGetClientLoading: false };

    case ActionTypes.GET_CONTACTS_FAVORITES[REQUEST]:
      return { ...state, favoritesAreLoaded: false };
    case ActionTypes.GET_CONTACTS_FAVORITES[SUCCESS]:
      return { ...state, favorites: action.data, favoritesAreLoaded: true };
    case ActionTypes.GET_CONTACTS_FAVORITES[FAILURE]:
      return { ...state, error: action.error, favoritesAreLoaded: false };

    default:
      return state;
  }
};

export default reducer;
